var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"am-icon",class:[
		`am-icon--${_vm.size}`,
		`am-icon--${_vm.theme}`,
		`icon icon-${_vm.name}`,
		{ 'is-dark': _vm.dark }
	]})
}
var staticRenderFns = []

export { render, staticRenderFns }